import { naviComputedFieldState } from "@/stores/navi";
import { shortUUID } from "@/utils/string.util";
import { List, Tooltip } from "antd";
import Link from "next/link";
import React from "react";
import { useRecoilValue } from "recoil";
import styles from "./styles.module.less";

const { container } = styles;

const History: React.FC = () => {
  const { filteredHistory } = useRecoilValue(naviComputedFieldState);

  return (
    <div className={container}>
      <List
        size="small"
        dataSource={filteredHistory.slice(0, 10)}
        renderItem={({ params, id }, index) => (
          <Tooltip title={params.term}>
            <List.Item>
              <Link
                href="/explore/navi/[id]"
                as={`/explore/navi/${shortUUID(id)}`}
              >
                <a>
                  <strong>{index + 1}.</strong> {params.term}
                </a>
              </Link>
            </List.Item>
          </Tooltip>
        )}
      />
    </div>
  );
};

export default History;
